<app-pageheader Title="Document Templates">
  <add-button AddRoute="settings/documenttemplates/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="communications/documenttemplates/searches" 
[AllowEdit]="true" EditUrl="settings/documenttemplates/:id/edit">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>